/**
 * 商品卡片渲染（列表页与首页共用）
 */
import { formatPrice } from './currency.js';

/** 图片加载失败时的兜底图 */
export function fallbackImage() {
  return './images/logo.png';
}

export function escapeHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function truncate(text, maxLen = 80) {
  if (!text) return '';
  return text.length > maxLen ? text.slice(0, maxLen) + '…' : text;
}

/** 富文本 HTML 转纯文本（列表页简介按纯文本展示，避免显示标签源码） */
export function toPlainText(html) {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(String(html), 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

/** 渲染单个商品卡片 */
export function renderProductCard(item) {
  const price = item.minPrice ? `<div class="product-card-price">${formatPrice(item.minPrice, item.priceUnit)}</div>` : '';
  const keywords = (item.keywords || '').trim();
  return `
    <article class="product-card">
      <a href="./product-detail.html?id=${item.id}" class="product-card-link">
        <div class="product-card-image">
          <img src="${item.image || fallbackImage()}" alt="${escapeHtml(item.name)}" loading="lazy" onerror="this.src='${fallbackImage()}'">
        </div>
        <div class="product-card-body">
          <h3 class="product-card-title">${escapeHtml(item.name)}</h3>
          ${keywords ? `<p class="product-card-keywords"><span>${escapeHtml(truncate(keywords, 120))}</span></p>` : ''}
          ${price}
          <button class="product-card-btn" data-i18n="products.readMore">Read More</button>
        </div>
      </a>
    </article>
  `;
}
